import { Deserializable } from '../deserializable';

export class UserProfile implements Deserializable{

  public id :number;
  public userId: number;
  public fullName: string = "";
  public displayName: string = "";
  public dob: string;
  public gender: string;
  public idNumber: string;
  public avatarId: number = 9;

  //Sars Info
  public sarsUsername: string;
  public sarsPassword: string;

  public adminSdaAmount: number;
  public adminFiaAmount: number;
  public incomeTaxReferenceNumber: string;


  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
